import React from 'react'
import { useIntl, FormattedMessage } from 'react-intl'
import { size } from 'utilities/object'
import { H2 as Heading } from 'components/typography/heading'
import Form from 'components/form/controller'
import StringField from 'components/form/field/string'
import Actions from 'components/form/actions'
import { Plain, ButtonSubmit } from 'components/button'

const AddSignatory = ({ onDone, setExternalSignatories, salt }) => {
    const { formatMessage } = useIntl()

    const add = body => {
        setExternalSignatories(previousSignatories => ([
            ...previousSignatories,
            body
        ]))

        onDone?.()
    }

    return (
        <Form
            layout="vertical"
            onSubmit={add}>
            {({ touched, errors, trigger }) => (
                <>
                    <Heading>
                        <FormattedMessage
                            id="document_action_add_external_signatory"
                            defaultMessage="Add external signatory" />
                    </Heading>
                    <StringField
                        salt={salt}
                        label={formatMessage({
                            id: 'person_label_name_given',
                            defaultMessage: 'Given name'
                        })}
                        field={{ required: true }}
                        name="givenName" />
                    <StringField
                        salt={salt}
                        label={formatMessage({
                            id: 'person_label_name_family',
                            defaultMessage: 'Family name'
                        })}
                        field={{ required: true }}
                        name="familyName" />
                    <StringField
                        salt={salt}
                        label={formatMessage({
                            id: 'person_label_emailaddress',
                            defaultMessage: 'Email address'
                        })}
                        name="email"
                        field={{ required: true }}
                        controlProps={{ type: 'email' }} />
                    <Actions>
                        <Plain
                            onClick={onDone}
                            className="neutral">
                            <FormattedMessage
                                id="action_cancel"
                                defaultMessage="Cancel" />
                        </Plain>
                        <ButtonSubmit
                            className="constructive"
                            disabled={!touched.length || !!size(errors)}
                            ref={trigger}>
                            <FormattedMessage
                                id="action_add"
                                defaultMessage="Add" />
                        </ButtonSubmit>
                    </Actions>
                </>
            )}
        </Form>
    )
}

export default AddSignatory
